module.exports = __webpack_public_path__ + "img/folder.47ec6e6f.png";